import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { API, getVisitorId, trackEvent } from "@/lib/tracking";
import { Mail } from "lucide-react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email, visitor_id: getVisitorId() });
      trackEvent("newsletter_signup", { label: email });
      toast.success("You're subscribed to The Vanguard. Thanks!");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" data-testid="newsletter-section" className="bg-rc-red">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <div className="flex items-center gap-2 font-mono text-white/80 text-xs uppercase tracking-[0.3em] mb-3">
            <Mail size={14} /> The Vanguard News Magazine
          </div>
          <h3 className="font-heading font-black text-white text-3xl lg:text-4xl leading-tight">
            Stay in the loop on Ranger news & projects.
          </h3>
        </div>
        <form data-testid="newsletter-form" onSubmit={submit} className="flex min-w-0 flex-col sm:flex-row gap-3">
          <input
            data-testid="newsletter-email"
            type="email"
            aria-label="Email address for company updates"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="min-w-0 flex-1 bg-white/10 border border-white/30 rounded-full text-white placeholder-white/50 px-5 py-4 outline-none focus:bg-white/20"
          />
          <button
            data-testid="newsletter-submit-button"
            type="submit"
            disabled={loading}
            className="bg-rc-charcoal text-white px-7 py-4 rounded-full font-bold uppercase tracking-[0.15em] text-sm hover:bg-black transition-colors disabled:opacity-60"
          >
            {loading ? "…" : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
}
